<template>
    <section>
        <div class="container">
            <div class="row center">
                <div class="card blue-grey darken-1">
                    <div class="card-action center">
                        <button class="waves-effect waves-light btn-floating darken-5 z-depth-3 btn red" @click="logOut">Salir del Sistema</button>
                    </div>
                </div>
            </div>
        </div> <!-- center -->
    </section>
</template>

<!-- ============================================================================= -->
<script>

    import {store}  from './../store/store.js'
    import firebase from 'firebase'

    /* :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */    
    export default {

        name: 'logout',
        data: function(){
            return {
            }
        },
        methods:{
            logOut(){

                const self = this;                
                firebase.auth().signOut()
                    .then(function(){

                        console.log("Exito en la Salida !");
                        self.$router.push('/');
                    })
                   .then(function () {

                      store.state.st_logeado = false;
                    })                     
                    .catch(function (error) {
                        console.log(error)
                    }) // catch()
            } // logOut()
        }, // methods
    } // export

</script>


// WEBPACK FOOTER //
// src/components/logout.vue